import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthStore } from '../auth.store';
@Component({
    selector: 'authenticate',
    templateUrl: './authenticate.component.html',
    standalone: false
})
export class AuthenticateComponent {
  public statusText: string;

  constructor(private readonly AuthStore: AuthStore, private readonly router: Router, private readonly route: ActivatedRoute, ) {

  }

}
